import { TItem } from '@/components/GridBoards/types';
import { THIRD_APP_ICON_CACHE } from '@/utils/THIRD_APP_ICON_CACHE';
import { getArea } from '../doWithSider';
import AppImg from '@/components/AppImg';

const createThirdApp = (
  props: {
    className: string;
    x?: number;
    y?: number;
    title: string;
  },
  siderbounds: LayoutBoxSiderbounds,
): TItem => {
  const icon = THIRD_APP_ICON_CACHE[props.className];
  return {
    id: props.className,
    w: 1,
    h: 1,
    x: props.x ?? -1,
    y: props.y ?? -1,
    repeat: false,
    isApp: true,
    area: getArea(siderbounds),
    render: () => {
      return (
        <div className='layout-app'>
          <div className='not-tr'>
            <AppImg src={icon} alt={props.title} draggable={false} />
            <span>{props.title}</span>
          </div>
        </div>
      );
    },
    renderPick: () => {
      return (
        <div className='layout-pick-app'>
          <AppImg src={icon} alt={props.title} draggable={false} />
          <span>
            {props.title}
            <br />
            (1 × 1)
          </span>
        </div>
      );
    },
  };
};

export default createThirdApp;
